export enum FilterBtnType {
	INCOMPLETED = 'incompleted',
	UNBLOCK = 'unblock',
	WITH_PARTNER_REQUEST = 'with_partner_request',
	WITH_INCOMPLETED_TASKS = 'with_incompleted_tasks',
	BLOCK_EXPIRES_SOON = 'block_expires_soon',
}

export const productDirectionSelectItems = [
	{ id: 'online', name: 'Без визита в банк' },
	{ id: 'offline', name: 'С визитом в банк' },
	{ id: 'online_manager', name: 'Без визита в банк (менеджер банка)' },
	{ id: 'refused_online', name: 'Без визита в банк (отклонен)' },
	{ id: 'delayed_online', name: 'Без визита в банк (ожидание)' },
]

export const activeSelectItems = [
	{ id: 'true', name: 'Активные' },
	{ id: 'false', name: 'Неактивные' },
]
